var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHcStartDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13.283a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM7.5 16.283a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM8.25 17.783a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM9.75 16.283a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM10.5 17.783a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM12 16.283a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM12.75 17.783a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM14.25 16.283a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM15 17.783a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM16.5 16.283a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zM15 13.283a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zM16.5 14.033a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z",
    fill: "#17C2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 2.783a.75.75 0 0 1 .75.75v1.5h9v-1.5a.75.75 0 0 1 1.5 0v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.033a3 3 0 0 1 3-3H6v-1.5a.75.75 0 0 1 .75-.75zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5z",
    fill: "#17C2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcStartDateIcon);
export default __webpack_public_path__ + "static/media/hc-start-date-icon.974f5d48d367516f5f30a5ed51b18eba.svg";
export { ForwardRef as ReactComponent };